import { connect } from 'react-redux';
import { compose, lifecycle, withHandlers } from 'recompose';
import { withRouter } from 'react-router';
import { isEmpty, pick } from 'lodash';

import { sendShopifyTokenToBackend } from '../../actions';
import { getShopBrandId } from '../../../../../auth/selectors';
import { fetchSettings } from '../../reducer/actions';
import { Logger } from '../../../../../../modules/infra/observability/logger';
import withToggle from '../../../../../common/hoc/withToggle';
import { t } from '../../../../../../modules/infra/i18n';

const mapStateToProps = state => ({
  brandId: getShopBrandId(state),
});

const mapDispatchToProps = {
  fetchSettings,
};

const withShopifyConnectionSave = compose(
  withRouter,
  withToggle('initialized', false),
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    checkLocationQueryParams: ({ brandId, location, ...props }) => async () => {
      const authorizeInformation = pick(location.query, ['code', 'hmac', 'host', 'shop', 'state', 'timestamp']);

      if (isEmpty(authorizeInformation)) {
        props.initializedOn();

        return;
      }

      try {
        await sendShopifyTokenToBackend(brandId, 'shopify', authorizeInformation);
      } catch (error) {
        Logger.error('Send Shopify token to backend', {
          error,
          action: 'Send Shopify token to backend',
        });

        return;
      } finally {
        props.fetchSettings(brandId).finally(() => props.initializedOn());
      }

      props.addNotification({
        title: t('common:success_title'),
        level: 'success',
        message: t('settings:integrations.shopify.connection_success_message'),
      });

      props.router.push(props.router.location.pathname);
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.checkLocationQueryParams();
    },
  })
);

export default withShopifyConnectionSave;
